import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';
import PropTypes from '../_util/vue-types';
import BaseMixin from '../_util/BaseMixin';
import SelectPropTypes from './SelectPropTypes';
import SelectTag from './SelectTag';
import classnames from 'classnames';
import { getComponentFromProp, getListeners, getOptionProps } from '../_util/props-util';
import { toArray } from './util';
import warning from 'warning';

var Selector = {
  inheritAttrs: false,
  mixins: [BaseMixin],
  props: _extends({}, SelectPropTypes, {
    selectorValueList: PropTypes.array,
    disabled: PropTypes.bool,
    prefixCls: PropTypes.string.def('rc-select'),
    className: PropTypes.string,
    open: PropTypes.bool,
    multiple: PropTypes.oneOf([false, true, 'flatten']),
    shape: PropTypes.string,
    fieldNames: PropTypes.object,
    displayRender: PropTypes.func,
    showArrow: PropTypes.bool,
    choiceTransitionName: PropTypes.string,
    suffixIcon: PropTypes.any,
    clearIcon: PropTypes.any,
    removeIcon: PropTypes.any,
    maxTagTextLength: PropTypes.number,
    maxTagCount: PropTypes.number,
    maxTagPlaceholder: PropTypes.any,
    __propsSymbol__: PropTypes.any
  }),
  inject: {
    Cascader: { 'default': function _default() {
        return {};
      } }
  },
  data: function data() {
    var props = getOptionProps(this);
    warning(this.__propsSymbol__, 'Replace slots.default with props.children and pass props.__propsSymbol__');
    var state = {
      _value: this.getValueFromProps(props, true) // true: use default value
    };
    return _extends({}, state, this.getDerivedState(props, state));
  },

  watch: {
    __propsSymbol__: function __propsSymbol__() {
      _extends(this.$data, this.getDerivedState(getOptionProps(this), this.$data));
    }
  },
  methods: {
    getDerivedState: function getDerivedState(nextProps) {
      var newState = {};

      if ('value' in nextProps) {
        var value = this.getValueFromProps(nextProps);
        newState._value = value;
      }
      return newState;
    },
    getValueFromProps: function getValueFromProps(props, useDefaultValue) {
      var value = [];
      if ('value' in props && !useDefaultValue) {
        value = toArray(props.value);
      }
      if ('defaultValue' in props && useDefaultValue) {
        value = toArray(props.defaultValue);
      }
      return value;
    },
    defaultDisplayRender: function defaultDisplayRender(_ref) {
      var labels = _ref.labels,
          selectedOptions = _ref.selectedOptions;
      var h = this.$createElement;
      var props = this.$props,
          onMultipleSelectorRemove = this.Cascader.onMultipleSelectorRemove;
      var multiple = props.multiple;

      var listeners = getListeners(this);

      if (multiple) {
        var selectTagProps = {
          props: _extends({}, props, {
            selectorValueList: selectedOptions
          }),
          on: _extends({}, listeners, { remove: onMultipleSelectorRemove })
        };
        var selectedValueNodes = h(SelectTag, selectTagProps);
        return selectedValueNodes;
      } else {
        return labels && labels.join('/');
      }
    },
    getPlaceholderElement: function getPlaceholderElement() {
      var h = this.$createElement;
      var props = this.$props,
          state = this.$data;


      var hidden = false;
      var value = state._value;
      if (value.length) {
        hidden = true;
      }

      var placeholder = props.placeholder;
      if (placeholder) {
        var p = {
          on: {
            mousedown: function mousedown(e) {
              return e.preventDefault();
            },
            click: this.onPlaceholderClick
          },
          // attrs: UNSELECTABLE_ATTRIBUTE,
          style: {
            display: hidden ? 'none' : 'block'
            // ...UNSELECTABLE_STYLE,
          },
          'class': props.prefixCls + '-selection__placeholder'
        };
        return h(
          'div',
          p,
          [placeholder]
        );
      }
      return null;
    },
    onPlaceholderClick: function onPlaceholderClick() {},
    renderSelector: function renderSelector() {
      var h = this.$createElement;
      var props = this.$props,
          $scopedSlots = this.$scopedSlots,
          defaultDisplayRender = this.defaultDisplayRender;
      var prefixCls = props.prefixCls,
          multiple = props.multiple,
          value = props.value,
          _props$selectorValueL = props.selectorValueList,
          selectorValueList = _props$selectorValueL === undefined ? [] : _props$selectorValueL,
          _props$displayRender = props.displayRender,
          displayRender = _props$displayRender === undefined ? $scopedSlots.displayRender || defaultDisplayRender : _props$displayRender;

      var className = prefixCls + '-selection__rendered';
      var innerNode = null;
      if (multiple) {
        innerNode = displayRender({
          labels: selectorValueList.map(function (item) {
            return item.label;
          }),
          selectedOptions: selectorValueList
        });
      } else {
        var selectedValue = null;
        if (value.length) {
          selectedValue = h(
            'div',
            { key: 'value', 'class': prefixCls + '-selection-selected-value' },
            [displayRender({
              labels: selectorValueList.map(function (item) {
                return item.label;
              }),
              selectedOptions: selectorValueList
            })]
          );
        }
        innerNode = [selectedValue];
      }
      return h(
        'div',
        { 'class': className },
        [this.getPlaceholderElement(), innerNode]
      );
    },
    renderArrow: function renderArrow() {
      var h = this.$createElement;
      var _$props = this.$props,
          prefixCls = _$props.prefixCls,
          showArrow = _$props.showArrow;

      if (!showArrow) {
        return null;
      }
      var suffixIcon = getComponentFromProp(this, 'suffixIcon');
      return h(
        'span',
        { key: 'arrow', 'class': prefixCls + '-arrow', style: { outline: 'none' } },
        [suffixIcon]
      );
    },
    renderClear: function renderClear() {
      var h = this.$createElement;
      var _$props2 = this.$props,
          prefixCls = _$props2.prefixCls,
          allowClear = _$props2.allowClear,
          selectorValueList = _$props2.selectorValueList;
      var onSelectorClear = this.Cascader.onSelectorClear;


      if (!allowClear || !selectorValueList.length || !selectorValueList[0].value) {
        return null;
      }
      var clearIcon = getComponentFromProp(this, 'clearIcon');
      return h(
        'span',
        { key: 'clear', 'class': prefixCls + '-selection__clear', on: {
            'click': onSelectorClear
          }
        },
        [clearIcon]
      );
    }
  },
  render: function render() {
    var _wrapperCls;

    var h = arguments[0];

    var props = this.$props;
    var prefixCls = props.prefixCls,
        multiple = props.multiple,
        className = props.className,
        disabled = props.disabled,
        shape = props.shape,
        _props$open = props.open,
        open = _props$open === undefined ? false : _props$open,
        showArrow = props.showArrow,
        loading = props.loading;


    var selectionProps = {
      props: {},
      attrs: {
        role: 'combobox',
        'aria-autocomplete': 'list',
        'aria-haspopup': 'true'
        // 'aria-expanded': realOpen,
        // 'aria-controls': this.$data._ariaId,
      },
      'class': classnames(prefixCls + '-selection ' + prefixCls + '-selection--' + (multiple ? 'multiple' : 'single'), shape ? prefixCls + '-selection-' + shape : ''),
      key: 'selection'
    };
    var wrapperCls = (_wrapperCls = {}, _defineProperty(_wrapperCls, prefixCls, true), _defineProperty(_wrapperCls, prefixCls + '-open', open), _defineProperty(_wrapperCls, prefixCls + '-focused', open || !!this._focused), _defineProperty(_wrapperCls, prefixCls + '-disabled', disabled), _defineProperty(_wrapperCls, prefixCls + '-allow-clear', !!props.allowClear), _defineProperty(_wrapperCls, prefixCls + '-show-arrow', showArrow), _defineProperty(_wrapperCls, prefixCls + '-loading', !!loading), _wrapperCls);

    return h(
      'div',
      { 'class': classnames(className, wrapperCls) },
      [h(
        'div',
        selectionProps,
        [this.renderSelector(), this.renderClear(), this.renderArrow()]
      )]
    );
  }
};

export default Selector;